import React from 'react';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const ClaimModal = ({
	open,
	setClose,
	onSuccess,
}: {
	open: boolean;
	setClose(period?: string): void;
	onSuccess?(): void;
}) => {
	const handleClose = (period?: string) => setClose(period);

	return (
		<Modal
			open={open}
			onClose={(event, reason) => {
				if (reason === 'backdropClick') return;
				handleClose();
			}}
			aria-labelledby="modal-title"
		>
			<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: 400,
					bgcolor: 'background.paper',
					border: '2px solid #000',
					boxShadow: 24,
					p: 3,
					borderRadius: '8px',
					outline: 'none',
				}}
			>
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					sx={{ mb: 1 }}
				>
					<Box
						display="flex"
						alignItems="center"
						flexDirection={'row'}
					>
						<Typography
							id="modal-title"
							variant="h6"
							component="h2"
						>
							Claim
						</Typography>
						<Box width={5} />
					</Box>
					<IconButton
						onClick={() => handleClose()}
						sx={{
							color: 'inherit',
						}}
					>
						<CloseIcon />
					</IconButton>
				</Box>
				<Box
					display="flex"
					alignItems="center"
					flexDirection={'row'}
					sx={{ mb: 2 }}
				>
					<Typography id="modal-title" variant="h6" component="h2">
						Please confirm if you want to claim processing time: 1
						day
					</Typography>
					<Box width={5} />
				</Box>
				<Box height={15} />
				<Box
					display="flex"
					justifyContent="space-between"
					flexDirection="column"
				>
					<Button
						variant={'contained'}
						color="primary"
						onClick={() => onSuccess?.()}
						size={'large'}
					>
						Claim
					</Button>
					<Box height={10} />
				</Box>
			</Box>
		</Modal>
	);
};
